import styled from 'styled-components/macro'
import { Grid } from '../../layout/grid'

export const DayNamesGrid = styled(Grid)``

export const DayName = styled.div``
